/*
 Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { isNil } from "lodash";
import moment from "moment";
import "moment/locale/fr";
import { ApiService } from "./Api";
import { SearchService } from "./Search";
import { SearchPublicService } from "./SearchPublic";
import { WpApiService } from "./WpApi";

export class Services {
    //static _api;
    //static _search;

    static get api() {
        if (isNil(this._api)) {
            const apiUrl = window.location.host.includes("staging")
                ? window.process.env.APP_DIODE_API_STAGING_BASE_URL
                : window.process.env.APP_DIODE_API_LIVE_BASE_URL;
            this._api = new ApiService({ apiUrl });
        }

        return this._api;
    }

    static get wpApi() {
        if (isNil(this._wpApi)) {
            const wpApiUrl = window.location.host.includes("staging")
                ? window.process.env.APP_DIODE_WP_STAGING_BASE_URL
                : window.process.env.APP_DIODE_WP_LIVE_BASE_URL;
            this._wpApi = new WpApiService({ wpApiUrl });
        }

        return this._wpApi;
    }

    static get search() {
        if (isNil(this._search)) {
            this._search = new SearchService();
            this._search.init();
        }
        return this._search;
    }

    static get searchPublic() {
        if (isNil(this._searchPublic)) {
            this._searchPublic = new SearchPublicService();
            this._searchPublic.init();
        }
        return this._searchPublic;
    }

    static get moment() {
        if (isNil(this._moment)) {
            this._moment = moment;
            this._moment.locale("fr_FR");
        }
        return this._moment;
    }
}
